/* ========================== */
/* ========= import ========= */
/* ========================== */
/* ====== React ====== */
import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { InputErrorMessage } from '02CommonUiParts/TableParts/InputErrorMessage';

/* ========================== */
/* ========= Styles ========= */
/* ========================== */

/* ====== Styled Components ====== */
const SdivInputGroupA = styled.div` //インプットのグループA
    height: ${props => props.inputGroupHeight ? props.inputGroupHeight : ''};
    align-items: center;
`;
const SdivInputGroupB = styled.div` //インプットのグループB
    height: ${props => props.inputGroupHeight ? props.inputGroupHeight : ''};
    align-items: center;
    display: flex;
`;
const SdivInputTileLabel = styled.div`//入力項目のタイトル
    white-space: nowrap;
    display: flex;
    align-items: center;

`;
const Sinput = styled.input` //入力欄
    height:28px;
    width: ${props => props.type === 'search' ? '95%' : 'calc(100% - 20px)'};
    padding:0 5px;
    margin: 2px 0;
    border-radius:3px;
    border: ${props => props.readOnly ? 'transparent' : '1px solid #C0C0C0'};
    background-color:${props => props.readOnly ? 'transparent' :props.isDirty? assets().color.lightYellow : 'white'};
    &:focus{
        outline: solid 1.5px ${assets().color.focusOutline};
    }
    &:disabled{
        color:black;
        opacity:1;
        background-color:${props => props.readOnly ? 'red' : assets().color.disabled};
        border:${assets().color.disabled};
    }
    &:disabled&::placeholder{
        color: transparent;
    }
    &:read-only{
        outline: none;
        cursor: inherit;
    };
    &:read-only&::placeholder{
        color: transparent;
    };
    box-sizing: content-box;
    
`;
const Slabel = styled.label` //ラベル表示
    margin:0 0 0 6px;
    height:32px;
    display:flex;
    align-items: center;
`;
const SoptionRange = styled.option`//選択肢（オプション）
    position: relative;
    display: block;
    padding: 0 22px;
    border-bottom: 1px solid #b5b5b5;
    font-size: ${assets().size.baseText};
    font-weight: bold;
    line-height: 20px;
    cursor: pointer;
    transition: all .4s ease-in-out;
`;
/* =============================== */  
/* ====== table用inputList ======= */  
/* =============================== */  
export const TableInputList = (props) => {
    /* =============================== */  
    /* ========== variables ========== */  
    /* =============================== */  
    const { title, placeholder, defaultValue, register, maxLength, width, disabled, rightLabel, range , errorMessage, readOnly,noDefault,list, isDirty} = props;

    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */
    return (
        <SdivInputGroupA>
            {title?<SdivInputTileLabel className='baseText' style={{fontSize:assets().size.baseText}}>{title}</SdivInputTileLabel>:<></>}
            <Sinput 
                {...register}
                isDirty={isDirty}
                autoComplete='off'
                maxLength={maxLength}
                size={maxLength}
                disabled={disabled}
                readOnly={readOnly}
                style={{fontSize:assets().size.baseText,height: `calc(${assets().size.inputHeight} + 1px)`,width:width}}
                defaultValue={defaultValue}
                placeholder={placeholder}
                type='search'
                list={list}
                className='inputText'
            />
                <datalist id = {list}>
                {(noDefault !== true) && <option value="" hidden>--選択--</option>}
                {range?.map((item, rangeIndex) => (
                    <SoptionRange
                        key={`${item.value}_${rangeIndex}`}
                        value={item.label ? item.value + ' ' + item.label : item.value}
                        className='baseText'
                        style={{fontSize:assets().size.baseText}}
                    >
                    </SoptionRange>
                ))}
            </datalist>
            {rightLabel && <Slabel className='baseText'style={{fontSize:assets().size.baseText}}>{rightLabel}</Slabel>}
            {errorMessage && <InputErrorMessage errorMessage={errorMessage}/>}
        </SdivInputGroupA>
    );
};
/* =============================== */  
/* == leftTitletable用inputList == */  
/* =============================== */  
export const LeftTitleTableInputList = (props) => {
    /* =============================== */  
    /* ========== variables ========== */  
    /* =============================== */  
    const { title, placeholder, defaultValue, register, maxLength, width, disabled, rightLabel, range , errorMessage, readOnly,noDefault,list, isDirty} = props;

    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */
    return (
        <SdivInputGroupB>
            {title?<SdivInputTileLabel className='baseText' style={{fontSize:assets().size.baseText}}>{title}</SdivInputTileLabel>:<></>}
            <Sinput 
                {...register} 
                isDirty={isDirty}
                autoComplete='off'
                maxLength={maxLength}
                size={maxLength}
                disabled={disabled}
                readOnly={readOnly}
                style={{fontSize:assets().size.baseText,height: `calc(${assets().size.inputHeight} + 1px)`,width:width}}
                defaultValue={defaultValue}
                placeholder={placeholder}
                type='search'
                list={list}
                className='inputText'
            />
                <datalist id = {list}>
                {(noDefault !== true) && <option value="" hidden>--選択--</option>}
                {range?.map((item, rangeIndex) => (
                    <SoptionRange
                        key={`${item.value}_${rangeIndex}`}
                        value={item.label ? item.value + ' ' + item.label : item.value}
                        className='baseText'
                        style={{fontSize:assets().size.baseText}}
                    >
                    </SoptionRange>
                ))}
            </datalist>
            {rightLabel && <Slabel className='baseText'style={{fontSize:assets().size.baseText}}>{rightLabel}</Slabel>}
            {errorMessage && <InputErrorMessage errorMessage={errorMessage}/>}
        </SdivInputGroupB>
    );
};